/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Unlock_LabelInputs */

const en_camera_unlock_label = /** @type {(inputs: Camera_Unlock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlock`)
};

const fr_camera_unlock_label = /** @type {(inputs: Camera_Unlock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déverrouiller`)
};

const ms_sg2_camera_unlock_label = /** @type {(inputs: Camera_Unlock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka kunci`)
};

/**
* | output |
* | --- |
* | "Unlock" |
*
* @param {Camera_Unlock_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const camera_unlock_label = /** @type {((inputs?: Camera_Unlock_LabelInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Unlock_LabelInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_camera_unlock_label(inputs)
	if (locale === "fr") return fr_camera_unlock_label(inputs)
	return ms_sg2_camera_unlock_label(inputs)
});